import React, { useContext } from 'react';
import Image from '../assets/imgSect5.svg';
import { MdOutlineSettingsSuggest } from "react-icons/md";
import { MdOutlineScreenSearchDesktop } from "react-icons/md";
import { HiOutlineLightBulb } from "react-icons/hi";


const StatsSection = () => {

  return (
    <section className="stats-section" id="stats">
      {/* Contenedor de la imagen */}
      <div className="stats-image-container">
        <img src={Image} alt="Gráfico" className="stats-image" />
      </div>

      {/* Contenedor del texto */}
      <div className="stats-text-container">
        <div className="space-y-2 tabs:space-y-6 mb:space-y-3">
          <h1 className="stats-heading">Estadísticas que Impulsan Decisiones</h1>
          <h3 className="stats-subheading">¡Transforma datos en decisiones poderosas!</h3>
          <p className="stats-paragraph">
            Con nuestras herramientas, identifica oportunidades de mejora, ajusta estrategias y asegura que tu equipo siempre esté alineado con tus objetivos de negocio.
          </p>
        </div>

        <div>
          <div className="stats-icon-text">
            <MdOutlineScreenSearchDesktop className="stats-icon" />
            <p>Monitorea el rendimiento con acceso instantáneo a datos clave</p>
          </div>
          <div className="stats-icon-text">
            <MdOutlineSettingsSuggest className="stats-icon" />
            <p>Ajusta estrategias con datos que te guían en cada paso</p>
          </div>
          <div className="stats-icon-text">
            <HiOutlineLightBulb className="stats-icon" />
            <p>Toma decisiones informadas al analizar y actuar con confianza</p>
          </div>
        </div>

        <a className="btn-primary" href="#contacto">Contáctanos</a>
      </div>
    </section>

  );
};

export default StatsSection;
